import { NO_ACTIVITY_THIS_PERIOD } from "@/lib/usage-messages";

export function UsageEmpty() {
  return <p className="text-sm text-muted-foreground">{NO_ACTIVITY_THIS_PERIOD}</p>;
}
